"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewId = exports.generateIDFromDate = exports.generateID = void 0;
const generateID = (itinID, sectionID, fieldId) => {
    if (fieldId) {
        return (itinID +
            '.' +
            sectionID +
            '.' +
            fieldId +
            '.' +
            Math.floor(100000000000 + Math.random() * 900000000000));
    }
    return (itinID +
        '.' +
        sectionID +
        '.' +
        Math.floor(100000000000 + Math.random() * 900000000000));
};
exports.generateID = generateID;
const generateIDFromDate = () => {
    return Date.now().toString() + '.' + Math.floor(10000 * Math.random());
};
exports.generateIDFromDate = generateIDFromDate;
const getNewId = (oldId) => {
    if (oldId.split('.').length === 1) {
        return oldId;
    }
    const [itin, section] = oldId.split('.');
    return (0, exports.generateID)(Number.parseInt(itin, 10), Number.parseInt(section, 10));
};
exports.getNewId = getNewId;
